/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import CommonComponents from '@app-ila/Common/CommonComponents';
import StyleConfig from '@app-ila/Common/StyleConfig';
import ContactUs from '@app-ila/Section/ContactUs';
import HeroSection from '@app-ila/Section/HeroSection';
import ILASection from '@app-ila/Section/ILASection';
import GenILAPrograms from '@app-ila/Section/GenILAPrograms';
import ILAWhatCanYou from '@app-ila/Section/ILAWhatCanYou';
import GenWhatCanYou from '@app-ila/Section/GenWhatCanYou';
import GenWhoShouldAttend from '@app-ila/Section/GenWhoShouldAttend';
import GenLocation from '@app-ila/Section/GenLocation';
import ImpactSection from '@app-ila/Section/ImpactSection';
import InitiativesLedBySadhguru from '@app-ila/Section/InitiativesLedBySadhguru';
import InsightIndepthTopCarousel from '@app-ila/Section/InsightIndepthTopCarousel';
import InsightPastSpeaker from '@app-ila/Section/InsightPastSpeaker';
import InsightTopCarouselSection from '@app-ila/Section/InsightTopCarouselSection';
import GenTopCarouselSection from '@app-ila/Section/GenTopCarouselSection';
import InsightVideo from '@app-ila/Section/InsightVideo';
import GenVideo from '@app-ila/Section/GenVideo';
import GenSaVideo from '@app-ila/Section/GenSaVideo';
import InsightWhyAttend from '@app-ila/Section/InsightWhyAttend';
import GenWhyAttend from '@app-ila/Section/GenWhyAttend';
import InterestedForm from '@app-ila/Section/InterestedForm';
import LeadersBanner from '@app-ila/Section/LeadersBanner';
import LeadershipPrograms from '@app-ila/Section/LeadershipPrograms';
import LookBackSection from '@app-ila/Section/LookBackSection';
import Offers from '@app-ila/Section/OfferSection';
import ParticipantsSharing from '@app-ila/Section/ParticipantsSharing';
import PastSpeakersShare from '@app-ila/Section/PastSpeakersShare';
import Pricing from '@app-ila/Section/PricingSection';
import GenPricing from '@app-ila/Section/GenPricingSection';
import PricingSectionInsightIndepth from '@app-ila/Section/PricingSectionInsightIndepth';
import ProgramOverview from '@app-ila/Section/ProgramOverview';
import SadhguruOnLeadership from '@app-ila/Section/SadhguruOnLeadership';
import StickyBar from '@app-ila/Section/StickyBar';
import SubscribeSection from '@app-ila/Section/SubscribeSection';
import WhatToExpect from '@app-ila/Section/WhatToExpect';
import LeaderReimagined from '@app-ila/components/Gallery/LeaderReimagined';
import MidContainer from '@app-ila/components/Layout/MidContainer';
import KeyResourceTestimonial from '@app-ila/components/Testimonial/KeyResourceTestimonial';
import HMMTopCarousel from '@app-ila/Section/HMMTopCarousel';
import HMMVideo from '@app-ila/Section/HMMVideo';
import HMMWhoThis from '@app-ila/Section/HMMWhoThis';
import HMMApproach from '@app-ila/Section/HMMApproach';
import HMMAbout from '@app-ila/Section/HMMAbout';
import HMM7Step from '@app-ila/Section/HMM7Step';
import ContactUsInfo from '@app-ila/Section/ContactUsInfo';

/**
 * Renders Render ILA Sections
 *
 * @param {object} sectionContent - Data
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @returns {ReactElement} Render ILA Sections
 */

const RenderSections = ({
  section,
  region,
  lang,
  pType,
  csrData,
  pageData,
  currRegion,
  mode,
}) => {
  const sectionId = section?.sectionId;

  if (sectionId === 'blogs') {
    return <></>;
  } else if (sectionId === 'top-banner-insight') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        minH={{ base: 'auto', lg: '600px' }}
      >
        <InsightTopCarouselSection sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'top-banner-geb') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        minH={{ base: 'auto', lg: '600px' }}
      >
        <GenTopCarouselSection sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'top-banner-insight-indepth') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        minH={{ base: 'auto', lg: '600px' }}
      >
        <InsightIndepthTopCarousel sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'key-resource-leader' || sectionId === 'key-resource-leader-indepth' || sectionId === 'key-resource-leader-hmm' || sectionId === 'key-resource-leader-gen-a') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        minH={{ base: 'auto', lg: '600px' }}
      >
        <KeyResourceTestimonial sectionContent={section.sectionContent} sectionId={sectionId} />
      </StyleConfig>
    );
  } else if (sectionId === 'sticky-bar') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        minH={{ base: 'auto', lg: '600px' }}
      >
        <StickyBar
          sectionContent={section.sectionContent}
          secId={section.sectionId}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'insight-intro') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        minH={{ base: 'auto', lg: '600px' }}
      >
        <InsightVideo sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'geb-intro') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        minH={{ base: 'auto', lg: '800px' }}
      >
        <GenVideo sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'geb-sa') { 
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        minH={{ base: 'auto', lg: '600px' }}
      >
        <GenSaVideo sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'ila-intro') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        minH={{ base: 'auto', lg: '600px' }}
      >
        <HeroSection sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'leadership-programs') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <LeadershipPrograms sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'leaders-banner') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <LeadersBanner sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'sadhguru-on-leadership') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <SadhguruOnLeadership sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'past-speakers-share') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <PastSpeakersShare sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'why-you-should-attend-section') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <InsightWhyAttend sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'gen-why-you-should-attend-section') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <GenWhyAttend sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'participant-sharings') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <ParticipantsSharing sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (currRegion !== 'us' && sectionId === 'offers-section') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <Offers sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (currRegion === 'us' && sectionId === 'offers-section-us') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <Offers sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'interested-form-section') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <InterestedForm
          sectionContent={section.sectionContent}
          secId={section.sectionId}
        />
      </StyleConfig>
    );
  } else if (sectionId === 'look-back-section') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <LookBackSection sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'what-to-expect-section') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <WhatToExpect sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  }
  if (sectionId === 'impact-section') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <ImpactSection sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'initiatives-led-by-sadhguru') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <InitiativesLedBySadhguru sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'program-pricing-section' || sectionId === 'program-pricing-hmm') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <Pricing sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'program-pricing-geb') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <GenPricing sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'program-pricing-insight-indepth') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <PricingSectionInsightIndepth sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'insight-from-past-speakers') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <MidContainer w="1330px" mx="auto">
          <InsightPastSpeaker sectionContent={section?.sectionContent} />
        </MidContainer>
      </StyleConfig>
    );
  } else if (sectionId === 'at-leadership-academy') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <MidContainer w="1330px" mx="auto">
          <ILASection sectionContent={section.sectionContent} />
        </MidContainer>
      </StyleConfig>
    );
  } else if (sectionId === 'location') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <MidContainer w="1102px" mx="auto">
        <GenLocation sectionContent={section.sectionContent} />
        </MidContainer>
      </StyleConfig>
    );
  } else if (sectionId === 'other-offerings-sa') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <MidContainer w="1061px" mx="auto">
        <GenILAPrograms sectionContent={section.sectionContent} />
        </MidContainer>
      </StyleConfig>
    );
  } else if (sectionId === 'who-should-attend') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <MidContainer w="1082px" mx="auto">
          <GenWhoShouldAttend sectionContent={section.sectionContent} />
        </MidContainer>
      </StyleConfig>
    );
  } else if (sectionId === 'what-you-can-expect') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <MidContainer w="1330px" mx="auto">
          <ILAWhatCanYou sectionContent={section.sectionContent} />
        </MidContainer>
      </StyleConfig>
    );
  } else if (sectionId === 'our-approach') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <MidContainer w="1177px" mx="auto">
          <GenWhatCanYou sectionContent={section.sectionContent} />
        </MidContainer>
      </StyleConfig>
    );
  } else if (sectionId === 'leadership-reimagined') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <MidContainer w="1330px" mx="auto">
          <LeaderReimagined sectionContent={section.sectionContent} />
        </MidContainer>
      </StyleConfig>
    );
  } else if (sectionId === 'newsletter-subscription') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <MidContainer w="100%" mx="auto">
          <SubscribeSection
            sectionContent={section.sectionContent}
            lang={lang}
          />
        </MidContainer>
      </StyleConfig>
    );
  } else if (sectionId === 'program-overview-section' || sectionId === 'program-overview-section-geb') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <ProgramOverview sectionContent={section.sectionContent} lang={lang} sectionId={sectionId} />
      </StyleConfig>
    );
  } else if (sectionId === 'contact' || sectionId === 'contact-us') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <ContactUs sectionContent={section.sectionContent} lang={lang} />
      </StyleConfig>
    );
  } else if (sectionId === 'contact-us-info') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <ContactUsInfo sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'top-banner-hmm') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        minH={{ base: 'auto', lg: '600px' }}
      >
        <HMMTopCarousel sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'hmm-intro') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        minH={{ base: 'auto', lg: '600px' }}
      >
        <HMMVideo sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'who-this-program-empowers') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <HMMWhoThis sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'hmm-our-approach') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <HMMApproach sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else if (sectionId === 'what-it-is-about') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <HMMAbout sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  }  else if (sectionId === 'hmm-7steps') {
    return (
      <StyleConfig
        id={section.sectionId}
        key={section.sectionId}
        pT="0"
        pB="0"
        mB="0"
        section={section}
      >
        <HMM7Step sectionContent={section.sectionContent} />
      </StyleConfig>
    );
  } else {
    return (
      <Box as="div" display="block" placeContent="center">
        {section?.sectionContent && section?.sectionContent?.length
          ? section?.sectionContent?.map((secCon, i) => {
              return (
                <StyleConfig
                  id={section?.sectionId}
                  key={section?.sectionId}
                  style={section?.styleConfig}
                  section={section}
                  // pB={{ base: '0', md: '15px' }}
                >
                  <CommonComponents
                    key={nanoid()}
                    sectionContent={secCon}
                    section={section}
                    region={region}
                    language={lang}
                    pType={pType}
                    csrData={csrData}
                    pageData={pageData}
                    index={i}
                    mode={mode}
                  />
                </StyleConfig>
              );
            })
          : null}
      </Box>
    );
  }
};

export default RenderSections;
